import { render, staticRenderFns } from "./UserTab.vue?vue&type=template&id=5101ed8d&scoped=true"
import script from "./UserTab.vue?vue&type=script&lang=js"
export * from "./UserTab.vue?vue&type=script&lang=js"
import style0 from "./UserTab.vue?vue&type=style&index=0&id=5101ed8d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5101ed8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5101ed8d')) {
      api.createRecord('5101ed8d', component.options)
    } else {
      api.reload('5101ed8d', component.options)
    }
    module.hot.accept("./UserTab.vue?vue&type=template&id=5101ed8d&scoped=true", function () {
      api.rerender('5101ed8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/user/UserTab.vue"
export default component.exports